export default theme => ({
  root: {
    height: 35,
  },
  label: {
    whiteSpace: "pre-wrap",
  },
});
